<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="btn-close btn-sm mr-2" aria-label="Close" aria-hidden="true" (click)="actionOnClose()"></button>
</div>